import { Expose } from 'class-transformer';
import { Model } from './model';
import { Category } from './category-model';
import { ApplicationType, Permissions } from '../../common';

export class AdminQuery extends Model {
  @Expose() email: string;
  @Expose() id: string;
  @Expose() fullName: string;
  @Expose({ name: 'username' }) userName: string;
  @Expose() isActive: boolean;
  @Expose() category: Category[];
  @Expose() permission: Permissions[];
  @Expose() appTypes: ApplicationType[];
}
